import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class BearCharacter extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene, x, y) {
    super(scene, x, y);

    this.busyTimeline = false;

    this.hat = ABCyaPhaser.Images.addImage(237.5, 71, UIAssetKeys._bear_hat_bitmap, this).setDisplayOrigin(41.5, 32);

    this.hatStandingFrames = [
      { angle: 0.2,x: 238,y: 71.3 },
      { angle: 0.5,x: 238.5,y: 71.5 },
      { angle: 0.7,x: 239.1,y: 71.8 },
      { angle: 1,x: 239.6,y: 72 },
      { angle: 1.2,x: 240.1,y: 72.3 },
      { angle: 1.5,x: 240.6,y: 72.5 },
      { angle: 1.7,x: 241.2,y: 72.8 },
      { angle: 2,x: 241.7,y: 73.1 },
      { angle: 2.2,x: 242.1,y: 73.3 },
      { angle: 2.5,x: 242.6,y: 73.6 },
      { angle: 2.7,x: 243.2,y: 73.8 },
      { angle: 3,x: 243.7,y: 74.1 },
      { angle: 3.2,x: 244.2,y: 74.3 },
      { angle: 3.5,x: 244.7,y: 74.6 },
      { angle: 3.7,x: 245.3,y: 74.9 },
      { angle: 3.9,x: 245.8,y: 75.1 },
      { angle: 4.2,x: 246.3,y: 75.4 },
      { angle: 4.4,x: 246.8,y: 75.6 },
      { angle: 4.2,x: 246.4,y: 75.4 },
      { angle: 4,x: 245.9,y: 75.2 },
      { angle: 3.8,x: 245.4,y: 75 },
      { angle: 3.6,x: 244.9,y: 74.7 },
      { angle: 3.3,x: 244.5,y: 74.5 },
      { angle: 3.1,x: 244,y: 74.3 },
      { angle: 2.9,x: 243.6,y: 74 },
      { angle: 2.7,x: 243.1,y: 73.8 },
      { angle: 2.4,x: 242.6,y: 73.5 },
      { angle: 2.2,x: 242.1,y: 73.3 },
      { angle: 2,x: 241.7,y: 73.1 },
      { angle: 1.8,x: 241.2,y: 72.9 },
      { angle: 1.6,x: 240.8,y: 72.7 },
      { angle: 1.3,x: 240.3,y: 72.4 },
      { angle: 1.1,x: 239.9,y: 72.2 },
      { angle: 0.9,x: 239.4,y: 71.9 },
      { angle: 0.7,x: 238.9,y: 71.7 },
      { angle: 0.4,x: 238.4,y: 71.4 },
      { angle: 0.2,x: 238,y: 71.2 },
      { angle: 0,x: 237.5,y: 71 },
    ];

    this.hatJumpingFrames = [
      {},
      {},
      { y: 67.3 },
      { y: 63.5 },
      { y: 59.8 },
      { y: 56 },
      { y: 59 },
      { y: 62 },
      { y: 65 },
      { y: 68 },
      { y: 71 },
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    this.hatLeaningFrames = [
      { angle: 1.2,x: 243.3,y: 70.9 },
      { angle: 2.4,x: 249.1,y: 70.7 },
      { angle: 3.6,x: 254.9,y: 70.6 },
      { angle: 4.8,x: 260.8,y: 70.4 },
      { angle: 6.1,x: 266.5,y: 70.3 },
      { angle: 7.3,x: 272.4,y: 70.1 },
      { angle: 8.5,x: 278.2,y: 70 },
      { angle: 7.1,x: 271.4,y: 70.2 },
      { angle: 5.7,x: 264.6,y: 70.3 },
      { angle: 4.2,x: 257.9,y: 70.5 },
      { angle: 2.8,x: 251,y: 70.7 },
      { angle: 1.4,x: 244.3,y: 70.8 },
      { angle: 0,x: 237.5,y: 71 },
    ];

    // blinking_eyes_bitmap
    this.blinkingEyes = ABCyaPhaser.Images.addImage(208,132.5, UIAssetKeys._bear_closed_eyes_bitmap, this).setDisplayOrigin(46, 21.5)
      .setVisible(false);

    // eyes_bitmap
    this.openEyes = ABCyaPhaser.Images.addImage(208, 131.5, UIAssetKeys._bear_eyes_bitmap, this).setDisplayOrigin(45, 22.5);

    this.openEyesStandingFrames = [
      { angle: 0.2,x: 208.3,y: 131.6 },
      { angle: 0.5,x: 208.5,y: 131.8 },
      { angle: 0.7,x: 208.8,y: 131.9 },
      { angle: 1,x: 209,y: 132 },
      { angle: 1.2,x: 209.3,y: 132.1 },
      { angle: 1.5,x: 209.6,y: 132.2 },
      { angle: 1.7,x: 209.8,y: 132.4 },
      { angle: 2,x: 210,y: 132.5 },
      { angle: 2.2,x: 210.4,y: 132.6 },
      { angle: 2.5,x: 210.6,y: 132.8 },
      { angle: 2.7,x: 210.9 },
      { angle: 3,x: 211.2,y: 132.9 },
      { angle: 3.2,x: 211.4,y: 133.1 },
      { angle: 3.5,x: 211.6,y: 133.2 },
      { angle: 3.7,x: 211.9,y: 133.3 },
      { angle: 3.9,x: 212.2,y: 133.5 },
      { angle: 4.2,x: 212.5,y: 133.6 },
      { angle: 4.4,x: 212.7,y: 133.7 },
      { angle: 4.2,x: 212.5,y: 133.6 },
      { angle: 4,x: 212.3,y: 133.5 },
      { angle: 3.8,x: 212,y: 133.4 },
      { angle: 3.6,x: 211.7,y: 133.3 },
      { angle: 3.3,x: 211.5,y: 133.1 },
      { angle: 3.1,x: 211.3,y: 133 },
      { angle: 2.9,x: 211,y: 132.9 },
      { angle: 2.7,x: 210.8 },
      { angle: 2.4,x: 210.6,y: 132.7 },
      { angle: 2.2,x: 210.4,y: 132.6 },
      { angle: 2,x: 210.1,y: 132.5 },
      { angle: 1.8,x: 209.9,y: 132.4 },
      { angle: 1.6,x: 209.7,y: 132.3 },
      { angle: 1.3,x: 209.4,y: 132.2 },
      { angle: 1.1,x: 209.2,y: 132 },
      { angle: 0.9,x: 208.9,y: 131.9 },
      { angle: 0.7,x: 208.7,y: 131.8 },
      { angle: 0.4,x: 208.5,y: 131.7 },
      { angle: 0.2,x: 208.2,y: 131.6 },
      { angle: 0,x: 208,y: 131.5 },
    ];

    this.openEyesJumpingFrames = [
      {},
      {},
      { y: 127.8 },
      { y: 124 },
      { y: 120.3 },
      { y: 116.5 },
      { y: 119.5 },
      { y: 122.5 },
      { y: 125.5 },
      { y: 128.5 },
      { y: 131.5 },
      {},
      {},
      {},
      {},
      {},
      {},
    ];

    this.openEyesLeaningFrames = [
      { angle: 1.2,x: 212.6,y: 130.7 },
      { angle: 2.4,x: 217.1,y: 129.8 },
      { angle: 3.6,x: 221.7,y: 128.9 },
      { angle: 4.8,x: 226.3,y: 128.1 },
      { angle: 6.1,x: 230.9,y: 127.2 },
      { angle: 7.3,x: 235.5,y: 126.4 },
      { angle: 8.5,x: 240.1,y: 125.6 },
      { angle: 7.1,x: 234.7,y: 126.6 },
      { angle: 5.7,x: 229.4,y: 127.6 },
      { angle: 4.2,x: 224.1,y: 128.6 },
      { angle: 2.8,x: 218.7,y: 129.5 },
      { angle: 1.4,x: 213.4,y: 130.5 },
      { angle: 0,x: 208,y: 131.5 },
    ];

    // head_bitmap
    this.head = ABCyaPhaser.Images.addImage(228.5,130.5, UIAssetKeys._bear_head_bitmap, this).setDisplayOrigin(81.5,80.5);

    this.headStandingFrames = [
      { angle: 0.2,x: 228.8,y: 130.7 },
      { angle: 0.5,x: 229,y: 130.9 },
      { angle: 0.7,x: 229.3,y: 131.1 },
      { angle: 1,x: 229.5,y: 131.3 },
      { angle: 1.2,x: 229.8,y: 131.6 },
      { angle: 1.5,x: 230,y: 131.7 },
      { angle: 1.7,x: 230.3,y: 131.9 },
      { angle: 2,x: 230.6,y: 132.2 },
      { angle: 2.2,x: 230.9,y: 132.4 },
      { angle: 2.5,x: 231.1,y: 132.6 },
      { angle: 2.7,x: 231.4,y: 132.8 },
      { angle: 3,x: 231.7,y: 133 },
      { angle: 3.2,x: 231.9,y: 133.2 },
      { angle: 3.5,x: 232.2,y: 133.4 },
      { angle: 3.7,x: 232.4,y: 133.6 },
      { angle: 3.9,x: 232.7,y: 133.8 },
      { angle: 4.2,x: 232.9,y: 134 },
      { angle: 4.4,x: 233.2,y: 134.2 },
      { angle: 4.2,x: 233,y: 134.1 },
      { angle: 4,x: 232.7,y: 133.9 },
      { angle: 3.8,x: 232.5,y: 133.6 },
      { angle: 3.6,x: 232.3,y: 133.5 },
      { angle: 3.3,x: 232,y: 133.3 },
      { angle: 3.1,x: 231.8,y: 133.1 },
      { angle: 2.9,x: 231.6,y: 132.9 },
      { angle: 2.7,x: 231.3,y: 132.7 },
      { angle: 2.4,x: 231.1,y: 132.6 },
      { angle: 2.2,x: 230.9,y: 132.4 },
      { angle: 2,x: 230.6,y: 132.2 },
      { angle: 1.8,x: 230.4,y: 132 },
      { angle: 1.6,x: 230.1,y: 131.8 },
      { angle: 1.3,x: 230,y: 131.7 },
      { angle: 1.1,x: 229.7,y: 131.5 },
      { angle: 0.9,x: 229.4,y: 131.2 },
      { angle: 0.7,x: 229.2,y: 131.1 },
      { angle: 0.4,x: 229,y: 130.9 },
      { angle: 0.2,x: 228.7,y: 130.7 },
      { angle: 0,x: 228.5,y: 130.5 },
    ];

    this.headJumpingFrames = [
      {},
      {},
      { y: 126.8 },
      { y: 123 },
      { y: 119.3 },
      { y: 115.5 },
      { y: 118.5 },
      { y: 121.5 },
      { y: 124.5 },
      { y: 127.5 },
      { y: 130.5 },
      {},
      {},
      {},
      {},
      {},
      {},
    ];

    this.headLeaningFrames = [
      { angle: 1.2,x: 233.1,y: 130.1 },
      { angle: 2.4,x: 237.7,y: 129.7 },
      { angle: 3.6,x: 242.2,y: 129.2 },
      { angle: 4.8,x: 246.8,y: 128.8 },
      { angle: 6.1,x: 251.4,y: 128.4 },
      { angle: 7.3,x: 255.9,y: 127.9 },
      { angle: 8.5,x: 260.5,y: 127.5 },
      { angle: 7.1,x: 255.2,y: 128 },
      { angle: 5.7,x: 249.8,y: 128.5 },
      { angle: 4.2,x: 244.5,y: 129 },
      { angle: 2.8,x: 239.2,y: 129.5 },
      { angle: 1.4,x: 233.8,y: 130 },
      { angle: 0,x: 228.5,y: 130.5 },
    ];

    // coat_bitmap
    this.coat = ABCyaPhaser.Images.addImage(227, 254.5, UIAssetKeys._bear_coat_bitmap, this).setDisplayOrigin(73, 93.5);

    this.coatStandingFrames = [
      { angle: 0.2,x: 226.7,y: 254.7 },
      { angle: 0.5,x: 226.5,y: 254.9 },
      { angle: 0.7,x: 226.2,y: 255.1 },
      { angle: 1,x: 225.9,y: 255.2 },
      { angle: 1.2,x: 225.7,y: 255.4 },
      { angle: 1.5,x: 225.4,y: 255.6 },
      { angle: 1.7,x: 225.1,y: 255.8 },
      { angle: 2,x: 224.9,y: 255.9 },
      { angle: 2.2,x: 224.6,y: 256.2 },
      { angle: 2.5,x: 224.3,y: 256.3 },
      { angle: 2.7,x: 224,y: 256.5 },
      { angle: 3,x: 223.7,y: 256.6 },
      { angle: 3.2,x: 223.5,y: 256.9 },
      { angle: 3.5,x: 223.2,y: 257 },
      { angle: 3.7,x: 222.9,y: 257.2 },
      { angle: 3.9,x: 222.7,y: 257.4 },
      { angle: 4.2,x: 222.4,y: 257.6 },
      { angle: 4.4,x: 222.2,y: 257.7 },
      { angle: 4.2,x: 222.4,y: 257.6 },
      { angle: 4,x: 222.6,y: 257.4 },
      { angle: 3.8,x: 222.9,y: 257.3 },
      { angle: 3.6,x: 223.1,y: 257.1 },
      { angle: 3.3,x: 223.4,y: 257 },
      { angle: 3.1,x: 223.6,y: 256.8 },
      { angle: 2.9,x: 223.9,y: 256.7 },
      { angle: 2.7,x: 224.1,y: 256.5 },
      { angle: 2.4,x: 224.3,y: 256.3 },
      { angle: 2.2,x: 224.6,y: 256.2 },
      { angle: 2,x: 224.8,y: 256 },
      { angle: 1.8,x: 225,y: 255.8 },
      { angle: 1.6,x: 225.3,y: 255.6 },
      { angle: 1.3,x: 225.6,y: 255.5 },
      { angle: 1.1,x: 225.8,y: 255.3 },
      { angle: 0.9,x: 226,y: 255.2 },
      { angle: 0.7,x: 226.3,y: 255 },
      { angle: 0.4,x: 226.5,y: 254.8 },
      { angle: 0.2,x: 226.8,y: 254.7 },
      { angle: 0,x: 227,y: 254.5 },
    ];

    this.coatJumpingFrames = [
      {},
      {},
      { y: 250.8 },
      { y: 247 },
      { y: 243.3 },
      { y: 239.5 },
      { y: 242.5 },
      { y: 245.5 },
      { y: 248.5 },
      { y: 251.5 },
      { y: 254.5 },
      {},
      {},
      {},
      {},
      {},
      {},
    ];

    this.coatLeaningFrames = [
      { angle: 1.2,x: 229,y: 253.9 },
      { angle: 2.4,x: 230.9,y: 253.2 },
      { angle: 3.6,x: 232.8,y: 252.6 },
      { angle: 4.8,x: 234.8,y: 251.9 },
      { angle: 6.1,x: 236.8,y: 251.3 },
      { angle: 7.3,x: 238.7,y: 250.7 },
      { angle: 8.5,x: 240.7,y: 250 },
      { angle: 7.1,x: 238.4,y: 250.8 },
      { angle: 5.7,x: 236.2,y: 251.5 },
      { angle: 4.2,x: 233.9,y: 252.3 },
      { angle: 2.8,x: 231.6,y: 253 },
      { angle: 1.4,x: 229.3,y: 253.7 },
      { angle: 0,x: 227,y: 254.5 },
    ];

    // left_arm_bitmap
    this.leftArm = ABCyaPhaser.Images.addImage(166.5, 223, UIAssetKeys._bear_left_hand_bitmap, this).setDisplayOrigin(50.5, 23);

    this.leftArmStandingFrames = [
      { regX: 50.5,regY: 23,angle: 0.2,x: 166.4,y: 222.9 },
      { angle: 0.5,x: 166.3,y: 222.8 },
      { angle: 0.7,y: 222.6 },
      { angle: 1,x: 166.2,y: 222.5 },
      { angle: 1.2,x: 166.1,y: 222.4 },
      { angle: 1.5,x: 166,y: 222.3 },
      { angle: 1.7,x: 165.9,y: 222.1 },
      { angle: 2,x: 165.8,y: 222 },
      { angle: 2.2,y: 221.9 },
      { angle: 2.5,x: 165.7,y: 221.8 },
      { angle: 2.7,x: 165.6,y: 221.6 },
      { angle: 3,x: 165.5,y: 221.5 },
      { angle: 3.2,x: 165.4,y: 221.4 },
      { angle: 3.5,y: 221.3 },
      { angle: 3.7,x: 165.3,y: 221.1 },
      { angle: 3.9,x: 165.2 },
      { angle: 4.2,x: 165.1,y: 220.9 },
      { angle: 4.4,x: 165,y: 220.8 },
      { angle: 4.2,x: 165.1,y: 220.9 },
      { angle: 4,x: 165.2,y: 221 },
      { angle: 3.8,x: 165.3,y: 221.2 },
      { angle: 3.6 },
      { angle: 3.3,x: 165.4,y: 221.3 },
      { angle: 3.1,x: 165.5,y: 221.4 },
      { angle: 2.9,x: 165.6,y: 221.5 },
      { angle: 2.7,x: 165.7,y: 221.7 },
      { angle: 2.4,y: 221.8 },
      { angle: 2.2,x: 165.8,y: 221.9 },
      { angle: 2,y: 222 },
      { angle: 1.8,x: 166,y: 222.1 },
      { angle: 1.6,y: 222.2 },
      { angle: 1.3,x: 166.1,y: 222.3 },
      { angle: 1.1,y: 222.5 },
      { angle: 0.9,x: 166.2,y: 222.6 },
      { angle: 0.7,x: 166.3,y: 222.7 },
      { angle: 0.4,y: 222.8 },
      { angle: 0.2,x: 166.4,y: 222.9 },
      { angle: 0,x: 166.5,y: 223 },
    ];

    this.leftArmJumpingFrames = [
      {},
      {},
      { angle: 1.4,x: 166.8,y: 219 },
      { angle: 2.7,x: 167,y: 214.9 },
      { angle: 4.1,x: 167.2,y: 210.9 },
      { angle: 5.5,x: 167.5,y: 206.9 },
      { angle: 4.4,x: 167.3,y: 210.1 },
      { angle: 3.3,x: 167.1,y: 213.3 },
      { angle: 2.2,x: 166.9,y: 216.6 },
      { angle: 1.1,x: 166.7,y: 219.8 },
      { angle: 0,x: 166.5,y: 223 },
      {},
      {},
      {},
      {},
      {},
      {},
    ];

    this.leftArmLeaningFrames = [
      { angle: 1.2,x: 169.2,y: 221.1 },
      { angle: 2.4,x: 171.9,y: 219.3 },
      { angle: 3.6,x: 174.6,y: 217.3 },
      { angle: 4.8,x: 177.3,y: 215.4 },
      { angle: 6.1,x: 180,y: 213.6 },
      { angle: 7.3,x: 182.8,y: 211.7 },
      { angle: 8.5,x: 185.5,y: 209.9 },
      { angle: 7.1,x: 182.3,y: 212 },
      { angle: 5.7,x: 179.2,y: 214.3 },
      { angle: 4.2,x: 176,y: 216.4 },
      { angle: 2.8,x: 172.8,y: 218.6 },
      { angle: 1.4,x: 169.7,y: 220.8 },
      { angle: 0,x: 166.5,y: 223 },
    ];

    // right_arm_bitmap
    this.rightArm = ABCyaPhaser.Images.addImage(301,250, UIAssetKeys._bear_right_hand_bitmap, this).setDisplayOrigin(31, 45);

    this.rightArmStandingFrames = [
      { regX: 31,regY: 45,angle: 0.2,x: 300.6,y: 250.7 },
      { angle: 0.5,x: 300.2,y: 251.3 },
      { angle: 0.7,x: 299.8,y: 251.9 },
      { angle: 1,x: 299.4,y: 252.6 },
      { angle: 1.2,x: 299.1,y: 253.2 },
      { angle: 1.5,x: 298.7,y: 253.8 },
      { angle: 1.7,x: 298.3,y: 254.5 },
      { angle: 2,x: 297.9,y: 255 },
      { angle: 2.2,x: 297.5,y: 255.7 },
      { angle: 2.5,x: 297,y: 256.3 },
      { angle: 2.7,x: 296.6,y: 256.9 },
      { angle: 3,x: 296.3,y: 257.6 },
      { angle: 3.2,x: 295.9,y: 258.3 },
      { angle: 3.5,x: 295.5,y: 258.8 },
      { angle: 3.7,x: 295.1,y: 259.5 },
      { angle: 3.9,x: 294.7,y: 260.1 },
      { angle: 4.2,x: 294.2,y: 260.7 },
      { angle: 4.4,x: 293.8,y: 261.3 },
      { angle: 4.2,x: 294.2,y: 260.8 },
      { angle: 4,x: 294.5,y: 260.2 },
      { angle: 3.8,x: 295,y: 259.7 },
      { angle: 3.6,x: 295.3,y: 259.1 },
      { angle: 3.3,x: 295.7,y: 258.5 },
      { angle: 3.1,x: 296,y: 258 },
      { angle: 2.9,x: 296.4,y: 257.4 },
      { angle: 2.7,x: 296.7,y: 256.8 },
      { angle: 2.4,x: 297.1,y: 256.2 },
      { angle: 2.2,x: 297.5,y: 255.7 },
      { angle: 2,x: 297.8,y: 255.1 },
      { angle: 1.8,x: 298.2,y: 254.6 },
      { angle: 1.6,x: 298.5,y: 254 },
      { angle: 1.3,x: 298.9,y: 253.4 },
      { angle: 1.1,x: 299.3,y: 252.9 },
      { angle: 0.9,x: 299.6,y: 252.3 },
      { angle: 0.7,x: 300,y: 251.7 },
      { angle: 0.4,x: 300.3,y: 251.2 },
      { angle: 0.2,x: 300.7,y: 250.6 },
      { angle: 0,x: 301,y: 250 },
    ];

    this.rightArmJumpingFrames = [
      {},
      {},
      { angle: -1.9,x: 302,y: 245.2 },
      { angle: -3.9,x: 302.9,y: 240.3 },
      { angle: -5.8,x: 303.9,y: 235.5 },
      { angle: -7.7,x: 304.7,y: 230.6 },
      { angle: -6.2,x: 304,y: 234.5 },
      { angle: -4.6,x: 303.3,y: 238.4 },
      { angle: -3.1,x: 302.5,y: 242.3 },
      { angle: -1.5,x: 301.8,y: 246.2 },
      { angle: 0,x: 301,y: 250 },
      {},
      {},
      {},
      {},
      {},
      {},
    ];

    this.rightArmLeaningFrames = [
      { angle: 1.2,x: 303,y: 251 },
      { angle: 2.4,x: 304.9,y: 251.9 },
      { angle: 3.6,x: 306.9,y: 252.8 },
      { angle: 4.8,x: 308.9,y: 253.8 },
      { angle: 6.1,x: 310.8,y: 254.7 },
      { angle: 7.3,x: 312.7,y: 255.6 },
      { angle: 8.5,x: 314.6,y: 256.4 },
      { angle: 7.1,x: 312.3,y: 255.4 },
      { angle: 5.7,x: 310.1,y: 254.4 },
      { angle: 4.2,x: 307.8,y: 253.3 },
      { angle: 2.8,x: 305.6,y: 252.3 },
      { angle: 1.4,x: 303.3,y: 251.1 },
      { angle: 0,x: 301,y: 250 },
    ];

    // left_leg_bitmap
    this.leftLeg = ABCyaPhaser.Images.addImage(189.5, 344.5, UIAssetKeys._bear_left_leg_bitmap, this).setDisplayOrigin(15.5, 47.5);

    this.leftLegJumpingFrames = [
      {},
      {},
      { angle: 3.7,y: 340.7 },
      { angle: 7.5,y: 337 },
      { angle: 11.2,y: 333.2 },
      { angle: 15,y: 329.5 },
      { angle: 12,y: 332.5 },
      { angle: 9,y: 335.5 },
      { angle: 6,y: 338.5 },
      { angle: 3,y: 341.5 },
      { angle: 0,y: 344.5 },
      {},
      {},
      {},
      {},
      {},
      {},
    ];

    this.leftLegLeaningFrames = [
      { angle: 1.2,x: 189.6,y: 343 },
      { angle: 2.4,x: 189.8,y: 341.3 },
      { angle: 3.6,x: 189.9,y: 339.8 },
      { angle: 4.8,x: 190,y: 338.2 },
      { angle: 6.1,x: 190.1,y: 336.7 },
      { angle: 7.3,x: 190.3,y: 335 },
      { angle: 8.5,x: 190.4,y: 333.5 },
      { angle: 7.1,x: 190.2,y: 335.3 },
      { angle: 5.7,x: 190,y: 337.2 },
      { angle: 4.2,x: 189.9,y: 339 },
      { angle: 2.8,x: 189.8,y: 340.8 },
      { angle: 1.4,x: 189.7,y: 342.7 },
      { angle: 0,x: 189.5,y: 344.5 },
    ];

    // right_leg_bitmap
    this.rightLeg = ABCyaPhaser.Images.addImage(264.5,344.5, UIAssetKeys._bear_right_leg_bitmap, this).setDisplayOrigin(15.5, 47.5);

    this.rightLegJumpingFrames = [
      {},
      {},
      { angle: -3.7,y: 340.8 },
      { angle: -7.5,y: 337 },
      { angle: -11.2,y: 333.3 },
      { angle: -15,y: 329.5 },
      { angle: -12,y: 332.5 },
      { angle: -9,y: 335.5 },
      { angle: -6,y: 338.5 },
      { angle: -3,y: 341.5 },
      { angle: 0,y: 344.5 },
      {},
      {},
      {},
      {},
      {},
      {},
    ];

    // the original animation class adds the objects in reverse order, so fix the order
    this.reverse();

    ABCyaPhaser.Container.setContainerInteractive(this, false);
  }

  goToIdleAnimationState() {
    this.busyTimeline = false;

    this.standingState?.stop();
    this.jumpingState?.stop();
    this.blinkState?.stop();
    this.leaningState?.stop();

    this.hat.setPosition(237.5, 71).setAngle(0)
      .setDisplayOrigin(41.5, 32);

    // blinking_eyes_bitmap
    this.blinkingEyes.setPosition(208,132.5).setAngle(0)
      .setVisible(false)
      .setDisplayOrigin(46, 21.5);

    // eyes_bitmap
    this.openEyes.setPosition(208, 131.5).setAngle(0)
      .setDisplayOrigin(45, 22.5)
      .setVisible(true);

    // head_bitmap
    this.head.setPosition(228.5,130.5).setAngle(0)
      .setDisplayOrigin(81.5,80.5);

    // coat_bitmap
    this.coat.setPosition(227, 254.5).setAngle(0)
      .setDisplayOrigin(73, 93.5);

    // left_arm_bitmap
    this.leftArm.setPosition(166.5, 223).setAngle(0)
      .setDisplayOrigin(50.5, 23);

    // right_arm_bitmap
    this.rightArm.setPosition(301,250).setAngle(0)
      .setDisplayOrigin(31, 45);

    // left_leg_bitmap
    this.leftLeg.setPosition(189.5, 344.5).setAngle(0)
      .setDisplayOrigin(15.5, 47.5);

    // right_leg_bitmap
    this.rightLeg.setPosition(264.5,344.5).setAngle(0)
      .setDisplayOrigin(15.5, 47.5);
  }

  playStandingAnimation() {
    if (this.standingState || this.busyTimeline) return;

    this.busyTimeline = true;

    this.jumpingState?.stop();
    this.blinkState?.stop();
    this.leaningState?.stop();

    const standingAnimationDuration = 1583;

    /** @type {Phaser.Tweens.Tween} */
    this.standingState = this.scene.tweens.add({
      targets: { value: 1 },
      props: { value: 38 },
      duration: standingAnimationDuration,
      ease: Phaser.Math.Easing.Linear,
      onStart: () => {
        // set the initial positions
        const hatFrame = this.hatStandingFrames[0];
        this.hat.setPosition(hatFrame.x, hatFrame.y).setAngle(hatFrame.angle);

        this.blinkingEyes.setVisible(false);

        const eyesFrame = this.openEyesStandingFrames[0];
        this.openEyes.setPosition(eyesFrame.x, eyesFrame.y).setAngle(eyesFrame.angle);

        const headFrame = this.headStandingFrames[0];
        this.head.setPosition(headFrame.x, headFrame.y).setAngle(headFrame.angle);

        const coatFrame = this.coatStandingFrames[0];
        this.coat.setPosition(coatFrame.x, coatFrame.y).setAngle(coatFrame.angle);

        const leftArmFrame = this.leftArmStandingFrames[0];
        this.leftArm.setPosition(leftArmFrame.x, leftArmFrame.y).setAngle(leftArmFrame.angle)
          .setDisplayOrigin(leftArmFrame.regX, leftArmFrame.regY);

        const rightArmFrame = this.rightArmStandingFrames[0];
        this.rightArm.setPosition(rightArmFrame.x, rightArmFrame.y).setAngle(rightArmFrame.angle)
          .setDisplayOrigin(rightArmFrame.regX, rightArmFrame.regY);

        this.leftLeg.setPosition(189.5, 344.5).setAngle(0)
          .setDisplayOrigin(15.5, 47.5);

        this.rightLeg.setPosition(264.5,344.5).setAngle(0)
          .setDisplayOrigin(15.5, 47.5);
      },
      onUpdate: (tween, target) => {
        // the standing animation is just a bunch of frames
        const frame = Math.ceil(target.value);

        const hatFrame = this.hatStandingFrames[frame - 1];
        this.hat.setPosition(hatFrame.x, hatFrame.y).setAngle(hatFrame.angle);

        const eyesFrame = this.openEyesStandingFrames[frame - 1];
        this.openEyes.setPosition(eyesFrame.x, eyesFrame.y ?? this.openEyes.y).setAngle(eyesFrame.angle);

        const headFrame = this.headStandingFrames[frame - 1];
        this.head.setPosition(headFrame.x, headFrame.y).setAngle(headFrame.angle);

        const coatFrame = this.coatStandingFrames[frame - 1];
        this.coat.setPosition(coatFrame.x, coatFrame.y).setAngle(coatFrame.angle);

        const leftArmFrame = this.leftArmStandingFrames[frame - 1];
        this.leftArm.setPosition(leftArmFrame.x ?? this.leftArm.x, leftArmFrame.y ?? this.leftArm.y).setAngle(leftArmFrame.angle ?? this.leftArm.angle);

        const rightArmFrame = this.rightArmStandingFrames[frame - 1];
        this.rightArm.setPosition(rightArmFrame.x ?? this.rightArm.x, rightArmFrame.y ?? this.rightArm.y).setAngle(rightArmFrame.angle ?? this.rightArm.angle);

      },
      onComplete: () => {
        this.standingState = null;

        // play the idle animation
        this.goToIdleAnimationState();
      },
      onStop: () => {
        this.standingState = null;
      }
    });
  }

  playJumpingAnimation() {
    if (this.jumpingState || this.busyTimeline) return;

    this.busyTimeline = true;

    this.standingState?.stop();
    this.blinkState?.stop();
    this.leaningState?.stop();

    const jumpingAnimationDuration = 708;

    /** @type {Phaser.Tweens.Tween} */
    this.jumpingState = this.scene.tweens.add({
      targets: { value: 1 },
      props: { value: 17 },
      duration: jumpingAnimationDuration,
      ease: Phaser.Math.Easing.Linear,
      onStart: () => {
        // set the initial positions
        this.hat.setPosition(237.5, 71).setAngle(0);

        this.blinkingEyes.setVisible(false);

        this.openEyes.setPosition(208,131.5).setAngle(0);

        this.head.setPosition(228.5,130.5).setAngle(0);

        this.coat.setPosition(227,254.5).setAngle(0);

        this.leftArm.setPosition(166.5, 223).setAngle(0)
          .setDisplayOrigin(50.5, 23);

        this.rightArm.setPosition(301, 250).setAngle(0)
          .setDisplayOrigin(31,45);

        this.leftLeg.setPosition(189.5,344.5).setAngle(0);

        this.rightLeg.setPosition(264.5,344.5).setAngle(0);
      },
      onUpdate: (tween, target) => {
        // the standing animation is just a bunch of frames
        const frame = Math.ceil(target.value);

        const hatFrame = this.hatJumpingFrames[frame - 1];
        this.hat.setPosition(this.hat.x, hatFrame.y ?? this.hat.y);

        const eyesFrame = this.openEyesJumpingFrames[frame - 1];
        this.openEyes.setPosition(this.openEyes.x, eyesFrame.y ?? this.openEyes.y);

        const headFrame = this.headJumpingFrames[frame - 1];
        this.head.setPosition(this.head.x, headFrame.y ?? this.head.y);

        const coatFrame = this.coatJumpingFrames[frame - 1];
        this.coat.setPosition(this.coat.x, coatFrame.y ?? this.coat.y);

        const leftArmFrame = this.leftArmJumpingFrames[frame - 1];
        this.leftArm.setPosition(leftArmFrame.x ?? this.leftArm.x, leftArmFrame.y ?? this.leftArm.y).setAngle(leftArmFrame.angle ?? this.leftArm.angle);

        const rightArmFrame = this.rightArmJumpingFrames[frame - 1];
        this.rightArm.setPosition(rightArmFrame.x ?? this.rightArm.x, rightArmFrame.y ?? this.rightArm.y).setAngle(rightArmFrame.angle ?? this.rightArm.angle);

        const leftLegFrame = this.leftLegJumpingFrames[frame - 1];
        this.leftLeg.setPosition(this.leftLeg.x, leftLegFrame.y ?? this.leftLeg.y).setAngle(leftLegFrame.angle ?? this.leftLeg.angle);

        const rightLegFrame = this.rightLegJumpingFrames[frame - 1];
        this.rightLeg.setPosition(this.rightLeg.x, rightLegFrame.y ?? this.rightLeg.y).setAngle(rightLegFrame.angle ?? this.rightLeg.angle);
      },
      onComplete: () => {
        this.jumpingState = null;

        // play the idle animation
        this.goToIdleAnimationState();
      },
      onStop: () => {
        this.jumpingState = null;
      }
    });
  }

  playBlinkAnimation() {
    if (this.blinkState || this.busyTimeline) return;

    this.busyTimeline = true;

    this.jumpingState?.stop();
    this.standingState?.stop();
    this.leaningState?.stop();

    const blinkingAnimationDuration = 208;

    /** @type {Phaser.Tweens.Tween} */
    this.blinkState = this.scene.tweens.add({
      targets: { value: 0 },
      props: { value: 1 },
      duration: blinkingAnimationDuration,
      ease: Phaser.Math.Easing.Linear,
      onStart: () => {
        // set the initial positions
        this.hat.setPosition(237.5, 71).setAngle(0);

        this.blinkingEyes.setVisible(true);

        this.openEyes.setVisible(false);

        this.head.setPosition(228.5,130.5).setAngle(0);

        this.coat.setPosition(227,254.5).setAngle(0);

        this.leftArm.setPosition(166.5, 223).setAngle(0)
          .setDisplayOrigin(50.5, 23);

        this.rightArm.setPosition(301, 250).setAngle(0)
          .setDisplayOrigin(31,45);

        this.leftLeg.setPosition(189.5,344.5).setAngle(0);

        this.rightLeg.setPosition(264.5,344.5).setAngle(0);
      },
      onComplete: () => {
        this.blinkState = null;

        // play the idle animation
        this.goToIdleAnimationState();
      },
      onStop: () => {
        this.blinkState = null;
      }
    });
  }

  playLeaningAnimation() {
    if (this.leaningState || this.busyTimeline) return;

    this.busyTimeline = true;

    this.standingState?.stop();
    this.blinkState?.stop();
    this.jumpingState?.stop();

    const leaningAnimationDuration = 583;

    /** @type {Phaser.Tweens.Tween} */
    this.leaningState = this.scene.tweens.add({
      targets: { value: 1 },
      props: { value: 13 },
      duration: leaningAnimationDuration,
      ease: Phaser.Math.Easing.Linear,
      onStart: () => {
        // set the initial positions
        this.hat.setPosition(237.5, 71).setAngle(0);

        this.blinkingEyes.setVisible(false);

        this.openEyes.setPosition(208,131.5).setAngle(0);

        this.head.setPosition(228.5,130.5).setAngle(0);

        this.coat.setPosition(227,254.5).setAngle(0);

        this.leftArm.setPosition(166.5, 223).setAngle(0)
          .setDisplayOrigin(50.5, 23);

        this.rightArm.setPosition(301, 250).setAngle(0)
          .setDisplayOrigin(31,45);

        this.leftLeg.setPosition(189.5,344.5).setAngle(0);

        this.rightLeg.setPosition(264.5,344.5).setAngle(0);
      },
      onUpdate: (tween, target) => {
        // the standing animation is just a bunch of frames
        const frame = Math.ceil(target.value);

        const hatFrame = this.hatLeaningFrames[frame - 1];
        this.hat.setPosition(hatFrame.x, hatFrame.y).setAngle(hatFrame.angle);

        const eyesFrame = this.openEyesLeaningFrames[frame - 1];
        this.openEyes.setPosition(eyesFrame.x, eyesFrame.y).setAngle(eyesFrame.angle);

        const headFrame = this.headLeaningFrames[frame - 1];
        this.head.setPosition(headFrame.x, headFrame.y).setAngle(headFrame.angle);

        const coatFrame = this.coatLeaningFrames[frame - 1];
        this.coat.setPosition(coatFrame.x, coatFrame.y).setAngle(coatFrame.angle);

        const leftArmFrame = this.leftArmLeaningFrames[frame - 1];
        this.leftArm.setPosition(leftArmFrame.x , leftArmFrame.y).setAngle(leftArmFrame.angle);

        const rightArmFrame = this.rightArmLeaningFrames[frame - 1];
        this.rightArm.setPosition(rightArmFrame.x , rightArmFrame.y).setAngle(rightArmFrame.angle);

        const leftLegFrame = this.leftLegLeaningFrames[frame - 1];
        this.leftLeg.setPosition(leftLegFrame.x, leftLegFrame.y).setAngle(leftLegFrame.angle);
      },
      onComplete: () => {
        this.leaningState = null;

        // play the idle animation
        this.goToIdleAnimationState();
      },
      onStop: () => {
        this.leaningState = null;
      }
    });
  }
}